import { Box, Button, Card, Container, InputBase, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Dialog, DialogTitle, DialogContent, TextField, DialogActions, MenuItem, Popover, Select, TableHead, CircularProgress, DialogContentText, FormControl, InputLabel, OutlinedInput, Chip, Tabs, Tab, Grid } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { file_URL } from '../../utils/url'

function SocialMediaHandler() {

    const [open, setOpen] = useState(null)
    const [formOpen, setFormOpen] = useState(false);
    const UserId = sessionStorage.getItem("userId");
    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType")
    const [assignedLeads, setAssignedLeads] = useState([]);
    const [dailyData, setDailyData] = useState("")
    const [view, setView] = useState([]);
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [selectedLead, setSelectedLead] = useState("");
    const [allUpdates, setAllUpdates] = useState([]);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState({})
    const [fileUpload, setFileUpload] = useState(null);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [events, setEvents] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [formData, setFormData] = useState({
        platform: '',
        postType: '',
        contentTopic: '',
        postCaption: '',
        hashtagsUsed: [],
        postedBy: "",
        postStatus: "",
        comments: "",
        scheduledDateTime: '',
        deadline: ''
    });

    const [convertData, setConvertData] = useState({
        serviceName: "Social Media",
        assignedTo: [],
        employeeWork: [],
        employeeWork: {},
        noOfPosters: [],
        deadline: [],
        status: [],
        serviceStatus: ""
    });

    const handleMultiSelectChange = (event) => {
        const {
            target: { value },
        } = event;
        setConvertData((prev) => ({
            ...prev,
            assignedTo: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        const lead = assignedLeads.find((data) => data._id === id);
        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedLead(lead);
            setSelectedWorkUpdateId(workUpdateId)
            setView(task);
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setFormOpen(false)
    }

    const handleFormOpen = async (leadId) => {
        handleCloseMenu();
        await getAllUsers();
        setSelectedLeadId(leadId);
        setConvertForm(true)
    }

    const handleFormClose = () => {
        setConvertForm(false)
    }

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            const filteredUsers = response.data.results.filter(user =>
                user.serviceTeamType && user.serviceTeamType.includes("Social Media")
            );

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error("Failed to load users");
        }
    };

    const convertLeads = async () => {
        debugger;
        try {
            const params = {
                serviceName: ["Social Media"],
                assignedTo: convertData.assignedTo,
                employeeWork: convertData.employeeWork,
                serviceStatus: "In Progress",
                noOfPosters: convertData.noOfPosters,
                deadline: convertData.deadline,
                status: convertData.status
            };

            const response = await putData(`leads/lead/${selectedLeadId}/status`, params, sessionToken);

            if (response.status === 200) {
                setConvertForm(false);
                toast.success("Lead converted successfully!");
            } else {
                toast.error("Failed to convert lead.");
            }
            await fetchAssignedLeads();
        } catch (error) {
            console.error("Error converting lead:", error);
            toast.error("Something went wrong while converting the lead.");
        }
    };

    const fetchAssignedLeads = async () => {
        try {
            let response;
            let socialMediaLeads = [];

            if (role === "Admin" || roleType === "Team Leader") {
                const params = { page: currentPage, limit: limit, serviceName: "Social Media" }
                response = await getData("leads/services", params, sessionToken);
                socialMediaLeads = response.data.results[0].paginatedResults;

                const totalRecords = response?.data.results[0]?.totalCount;
                setTotalPages(response?.data.results[0]?.totalPages);
                setTotalCount(totalRecords);
            } else if (roleType === "Employee") {
                const params = {
                    page: currentPage,
                    limit: limit
                };

                const endpoint = `leads/leads/${UserId}`;

                response = await getData(endpoint, params, sessionToken);

                if (roleType === "Employee" && response?.data) {
                    const leadsData = Array.isArray(response.data)
                        ? response.data[0]?.paginatedResults
                        : response.data[0]?.paginatedResults || [];

                    socialMediaLeads = leadsData;

                    const totalRecords = response?.data[0]?.totalCount?.totalItems;
                    setTotalPages(response.data[0].totalPages === null ? 0 : response.data[0].totalPages);
                    setTotalCount(totalRecords);

                }
            }

            setAssignedLeads(socialMediaLeads);
            console.log("Social Media", socialMediaLeads)

            const latestDeadlines = {};
            socialMediaLeads.forEach(lead => {
                const leadId = lead._id;
                const deadline = lead.socialMediaHistory?.deadline;
                if (deadline && (!latestDeadlines[leadId] ||
                    new Date(deadline) > new Date(latestDeadlines[leadId].deadline))) {
                    latestDeadlines[leadId] = lead;
                }
            });

            const latestDeadlinesArray = Object.values(latestDeadlines);

            const deadlineEvents = latestDeadlinesArray.map(lead => ({
                id: lead._id + '-deadline',
                title: `Deadline: ${lead.socialMediaHistory?.contentType || 'Content'}`,
                start: lead.socialMediaHistory?.deadline,
                allDay: true,
                extendedProps: {
                    type: 'deadline',
                    leadName: lead.name,
                    contentType: lead.socialMediaHistory?.contentType,
                    progress: lead.socialMediaHistory?.completionPercentage
                        ? `${Math.round(lead.socialMediaHistory.completionPercentage)}%`
                        : '0%'
                },
                backgroundColor: '#FF8A80',
                borderColor: '#FF8A80',
                textColor: '#000'
            }));

            setEvents(prevEvents => [...prevEvents, ...deadlineEvents]);

        } catch (err) {
            console.error("Error while fetching Social Media Team:", err);
            toast.error("Failed to load Social Media Team.");
        }
    };

    const getDailyUpdates = async () => {

        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Social Media Team:", err);
            toast.error("Failed to load Social Media Team.");
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Social Media");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData);

        } catch (err) {
            console.error("Error while fetching Social Media Team:", err);
            toast.error("Failed to load Social Media Team.");
        }

    }

    const teams = assignedLeads.map(task => `Team ${task.id}`);
    const totalVideos = assignedLeads.map(task => task.totalVideos);
    const completedVideos = assignedLeads.map(task => task.completedVideos);
    const pendingVideos = totalVideos.map((total, index) => total - completedVideos[index]);

    pendingVideos.forEach((pending, index) => {
        if (pending > 5) {
            console.log(`Notification: Team ${assignedLeads[index].id} has ${pending} pending videos!`);
        }
    });

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!");
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error("Error uploading file.");
        }
    };

    const postDailyUpdates = async () => {
        debugger
        try {

            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.socialMediaHistory?.map(history => history?.dailyUpdateId));

            const socialMediaHistory = selectedLead?.socialMediaHistory?.[0] ||
                selectedLead?.socialMediaHistory ||
                {};
            const assignedPosts = selectedLead?.socialMediaHistory?.[0]?.assignedPosts;
            const previousCompleted = socialMediaHistory.completedPosts;
            const newCompleted = parseInt(formData.completedPosts, 10);
            const totalCompleted = previousCompleted + newCompleted;
            const remainingShots = assignedPosts - newCompleted;

            const deadline = selectedLead?.socialMediaHistory?.[0]?.deadline ||
                selectedLead?.socialMediaHistory?.deadline ||
                '';
            const totalPosts = selectedLead?.socialMediaHistory?.[0]?.totalPosts ||
                selectedLead?.socialMediaHistory?.totalPosts ||
                '';
            const monthlyPosts = selectedLead?.socialMediaHistory?.[0]?.monthlyPosts ||
                selectedLead?.socialMediaHistory?.monthlyPosts ||
                '';
            const platform = selectedLead?.socialMediaHistory?.[0]?.platform ||
                selectedLead?.socialMediaHistory?.platform ||
                '';
            const postType = selectedLead?.socialMediaHistory?.[0]?.postType ||
                selectedLead?.socialMediaHistory?.postType ||
                '';
            const amount = selectedLead?.socialMediaHistory?.[0]?.amount ||
                selectedLead?.socialMediaHistory?.amount ||
                '';
            const assignedTo = selectedLead?.socialMediaHistory?.[0]?.assignedTo ||
                selectedLead?.socialMediaHistory?.assignedTo ||
                '';
            const status = selectedLead?.socialMediaHistory?.[0]?.completedPosts === selectedLead?.socialMediaHistory?.[0]?.totalPosts ? "Completed" : "Pending";

            const payLoad = {
                amount,
                assignedTo,
                leadId: selectedLeadId,
                platform: platform,
                postType: postType,
                postStatus: status,
                comments: formData.comments,
                deadline: deadline,
                userId: UserId,
                serviceName: "Social Media",
                totalPosts,
                monthlyPosts,
                completedPosts: totalCompleted,
                assignedPosts: remainingShots
            }

            let response;

            if (existingUpdates.length === 0) {
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                const updateId = existingUpdates[existingUpdates.length - 1];
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                console.log("Response:", response);
                toast.success("Daily Work Updated Successfully!");
                setFormOpen(false);
                handleCloseDialog();
                getDailyUpdates();
                fetchAssignedLeads();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error("Something went wrong. Please try again!");
        }

    }

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            fetchAssignedLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            fetchAssignedLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            fetchAssignedLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        fetchAssignedLeads(currentPage, limit);
        if (roleType === "Employee") {
            getDailyUpdates();
        }
    }, [role, roleType, serviceTeamType, currentPage, limit]);

    return (
        <>
            <Helmet>
                <title>Service | Social Media</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Social Media
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
                            {
                                (role === "Admin" || roleType === "Team Leader") && (
                                    <Tabs
                                        value={activeTab}
                                        onChange={(e, newValue) => setActiveTab(newValue)}
                                        aria-label="content creation views"
                                    >
                                        <Tab label="Calendar View" />
                                        <Tab label="Table View" />
                                    </Tabs>
                                )
                            }
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    {(role === "Admin" || roleType === "Team Leader") && activeTab === 0 && (
                        <Box sx={{ height: 500 }}>
                            <FullCalendar
                                plugins={[dayGridPlugin, interactionPlugin]}
                                initialView="dayGridMonth"
                                headerToolbar={{
                                    start: "",
                                    center: 'prev title next',
                                    end: ""
                                }}
                                events={events}
                                eventContent={renderEventContent}
                                height="100%"
                            />
                        </Box>
                    )}
                    {
                        ((role === "Admin" || roleType === "Team Leader") && activeTab === 1) || roleType === "Employee" ? (
                            <>
                                <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                    {
                                        role === "Admin" || roleType === "Team Leader" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    {/* <TableCell>Assigned User</TableCell> */}
                                                    <TableCell>Lead Name</TableCell>
                                                    {/* <TableCell>Email</TableCell> */}
                                                    <TableCell>Phone</TableCell>
                                                    <TableCell>Platform</TableCell>
                                                    <TableCell>Post Type</TableCell>
                                                    <TableCell>Assigned Posts</TableCell>
                                                    <TableCell>Completed Posts</TableCell>
                                                    <TableCell>File</TableCell>
                                                    <TableCell>Status</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        assignedLeads.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={9} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            assignedLeads?.map((task, id) => {
                                                                return (
                                                                    <TableRow key={task?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        {/* <TableCell>{task?.assignedTo?.name || task?.assignedToHistory[0]?.assignedUser?.name}</TableCell> */}
                                                                        <TableCell>{task?.name}</TableCell>
                                                                        {/* <TableCell>{task?.email}</TableCell> */}
                                                                        <TableCell>{task?.phone}</TableCell>
                                                                        <TableCell>{task?.socialMediaHistory?.platform}</TableCell>
                                                                        <TableCell>{task?.socialMediaHistory?.postType}</TableCell>
                                                                        <TableCell>{task?.socialMediaHistory?.assignedPosts ? task?.socialMediaHistory?.assignedPosts : "-"}</TableCell>
                                                                        <TableCell>{task?.socialMediaHistory?.completedPosts} / {task?.socialMediaHistory?.totalPosts}</TableCell>
                                                                        <TableCell>
                                                                            {task?.socialMediaHistory?.fileUpload?.path ?
                                                                                <img
                                                                                    src={task?.socialMediaHistory?.fileUpload?.path
                                                                                        ? `${file_URL + encodeURI(task?.socialMediaHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#"}
                                                                                    alt='Image.png'
                                                                                    style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        const fullImage = task?.socialMediaHistory?.fileUpload?.path
                                                                                            ? `${file_URL + encodeURI(task?.socialMediaHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                            : "#";
                                                                                        setSelectedImage(fullImage);
                                                                                        setOpenImage(true);
                                                                                    }}
                                                                                />
                                                                                : "-"}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={task?.socialMediaHistory?.progressPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {`${Math.round(task?.socialMediaHistory?.progressPercentage)}%`}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={
                                                                                    (event) => handleOpenMenu(event, task, task._id, task.socialMediaHistory?.dailyUpdateId)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : roleType === "Employee" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell>Contact</TableCell>
                                                    <TableCell>Assigned Work</TableCell>
                                                    <TableCell>deadline</TableCell>
                                                    <TableCell>Completed Posts</TableCell>
                                                    <TableCell>Progress</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        assignedLeads?.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={9} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            assignedLeads?.map((work, id) => {
                                                                return (
                                                                    <TableRow key={work?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        <TableCell>{work?.name}</TableCell>
                                                                        <TableCell>{work?.phone}</TableCell>
                                                                        <TableCell align="center">{work?.currentWork?.noOfPosters}</TableCell>
                                                                        <TableCell align="center">{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                                        <TableCell align="center">{work?.socialMediaHistory[0]?.completedPosts} / {work?.socialMediaHistory[0]?.totalPosts}</TableCell>
                                                                        {/* <TableCell>
                                                                            <img
                                                                                src={work?.socialMediaHistory[0]?.fileUpload?.path
                                                                                    ? `${file_URL+encodeURI(work?.socialMediaHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                    : "#"}
                                                                                alt='Image.png'
                                                                                style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    const fullImage = work?.socialMediaHistory[0]?.fileUpload?.path
                                                                                        ? `${file_URL+encodeURI(work?.socialMediaHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#";
                                                                                    setSelectedImage(fullImage);
                                                                                    setOpenImage(true);
                                                                                }}
                                                                            />
                                                                        </TableCell> */}
                                                                        <TableCell align="center">
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={work?.socialMediaHistory[0]?.progressPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {typeof work?.socialMediaHistory[0]?.progressPercentage === 'number'
                                                                                            ? `${Math.round(work.socialMediaHistory[0].progressPercentage)}%`
                                                                                            : '0%'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={(event) => handleOpenMenu(event, work, work._id, work?.socialMediaHistory[0]?.dailyUpdateId)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : null
                                    }
                                </TableContainer>
                                <PaginationComponent
                                    name={"Leads"}
                                    totalcount={totalCount}
                                    limit={limit}
                                    handleLimitChange={handleLimitChange}
                                    handlePrevPage={handlePrevPage}
                                    handleNextPage={handleNextPage}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                />
                            </>
                        ) : null}
                </Card>

                {/* Dialog for Adding Task */}
                <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
                    <DialogTitle>Daily Work Update!</DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            label="Completed Posts"
                            name="completedPosts"
                            value={formData.completedPosts}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField
                            margin="dense"
                            label="Comments"
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            fullWidth
                        />
                        {/* <TextField
                            select
                            margin="dense"
                            label="Post Status"
                            name="postStatus"
                            value={formData.postStatus}
                            onChange={handleChange}
                            fullWidth
                        >
                            {["Scheduled", "Posted", "Draft", "Pending Approval"].map((option) => (
                                <MenuItem key={option} value={option}>{option}</MenuItem>
                            ))}
                        </TextField> */}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="secondary">Cancel</Button>
                        <Button color="primary" onClick={postDailyUpdates}>Update</Button>
                    </DialogActions>
                </Dialog>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    {role === "Admin" ? (
                        <MenuItem onClick={handleOpenDialog}>
                            <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                            View
                        </MenuItem>
                    ) : roleType === "Team Leader" ? (
                        <>
                            <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                                <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                Convert
                            </MenuItem>
                            <MenuItem onClick={handleOpen}>
                                <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                Work Update
                            </MenuItem>
                        </>
                    ) : (
                        <>
                            <MenuItem onClick={handleOpen}>
                                <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                Work Update
                            </MenuItem>

                            <MenuItem sx={{ color: 'error.main' }}>
                                <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                Delete
                            </MenuItem>
                        </>
                    )}
                </Popover>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div"
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2'
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Post Type: {view?.socialMediaHistory?.postType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.socialMediaHistory?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id='paddingTop'>
                                                <Typography variant='body1'>
                                                    Content Topic: {view?.socialMediaHistory?.contentTopic}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.socialMediaHistory?.status === 'Completed' ? 'success.main' :
                                                            view?.socialMediaHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.socialMediaHistory?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid> */}
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Amount: {view?.socialMediaHistory?.amount}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id='paddingTop'>
                                                <Typography variant='body1'>
                                                    Platform: {view?.socialMediaHistory?.platform.join(' , ')}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Shots: {view?.socialMediaHistory?.completedPosts}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Shots: {view?.socialMediaHistory?.totalPosts}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    No of Reels / Posters: {view?.socialMediaHistory?.monthlyPosts}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.socialMediaHistory?.completionPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.socialMediaHistory?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        "{view?.[0]?.socialMediaHistory?.comments}"
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

                {/* Convert leads */}
                <Dialog open={convertForm} onClose={() => { setConvertForm(false) }}>
                    <DialogTitle>Convert Leads</DialogTitle>
                    <DialogContent>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="assign-to-label">Assign To</InputLabel>
                            <Select
                                labelId="assign-to-label"
                                multiple
                                value={convertData.assignedTo}
                                onChange={handleMultiSelectChange}
                                InputLabelProps={{ shrink: true }}
                                label="Assign To"
                                input={<OutlinedInput label="Assign To" />}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => {
                                            const employee = employeeOptions.find(emp => emp.id === value);
                                            return employee ? (
                                                <Chip key={value} label={employee.name} />
                                            ) : null;
                                        })}
                                    </Box>
                                )}
                                fullWidth
                            >
                                {employeeOptions.map((emp) => (
                                    <MenuItem key={emp.id} value={emp.id}>
                                        {emp.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{ mt: 2 }}>
                            {convertData.assignedTo.map((empId) => {
                                const employee = employeeOptions.find(emp => emp.id === empId);
                                return (
                                    <>
                                        <Box key={empId} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                                <div className='col' style={{ marginTop: "5px" }}>
                                                    <Typography>{employee?.name}</Typography>
                                                </div>
                                            </div>
                                        </Box>
                                        <Box key={empId} sx={{ alignItems: 'center', mb: 1, gap: 2 }}>
                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                                                <TextField
                                                    label="No of Posters"
                                                    value={convertData.employeeWork?.[empId]?.noOfPosters || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    noOfPosters: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                />
                                                <TextField
                                                    label="Deadline"
                                                    value={convertData.employeeWork?.[empId]?.deadline || ""}
                                                    onChange={(e) => {
                                                        const work = e.target.value;
                                                        setConvertData(prev => ({
                                                            ...prev,
                                                            employeeWork: {
                                                                ...prev.employeeWork,
                                                                [empId]: {
                                                                    ...prev.employeeWork?.[empId],
                                                                    deadline: work
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    type='date'
                                                    size="small"
                                                    fullWidth
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </div>
                                        </Box>
                                    </>
                                );
                            })}
                        </Box>
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={handleFormClose} color="secondary">Cancel</Button>
                        <Button onClick={convertLeads} color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>

            </Container>
        </>
    );
}

function renderEventContent(eventInfo) {
    const isDeadline = eventInfo.event.extendedProps.type === 'deadline';
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isDeadline ? '#FFEBEE' : '#F5F5F5',
            borderRadius: '8px',
            padding: '6px',
            marginTop: '5px',
            boxShadow: 2,
            fontSize: '12px',
            color: 'black',
            maxWidth: "125px",
            borderLeft: `4px solid ${eventInfo.event.backgroundColor || '#90CAF9'}`
        }}>
            <Box sx={{
                borderLeft: `4px solid ${eventInfo.event.extendedProps.color || '#90CAF9'}`,
                paddingLeft: '6px'
            }}>
                {isDeadline ? (
                    <>
                        <strong>⏰</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                ) : (
                    <>
                        <strong>📝 {eventInfo.event.title}</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Req: {eventInfo.event.extendedProps.requirement}</div>
                        <div>Status: {eventInfo.event.extendedProps.status}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                )}
            </Box>
        </Box>
    );
}

export default SocialMediaHandler;